define('google',['require','exports','module','async!https://apis.google.com/js/client:platform.js!onload'],function(require, exports, module) {
    require("async!https://apis.google.com/js/client:platform.js!onload");
    var config = module.config();

    exports.gapi = window.gapi;
    exports.clientId = config.clientId;
    exports.useWallet = config.useWallet;
});

